import Routes from '../routes.mjs';
import redirectToDomain from './redirectToDomain';

export const getTargetOrigin = (
  sourceOrigin,
  targetOriginSuffix = 'fashionunited.com',
) => sourceOrigin
  .replace(/https?:\/\/localhost(:\d+)?/, 'https://local.fashionunited.ie')
  .replace(
    // eslint-disable-next-line @stylistic/max-len
    /(-(au|bg|cn|cy|gr|ee|hr|lt|lv|mt|ro|ru|sk|si|dashboard)(\.))?((auau|bg|cn|cy|gr|ee|hr|lt|lv|mt|ro|ru|sk|si|dashboard)\.)?[^./]+\.((com\.[^.:]+)|([^.:]+))($|(?=:))/,
    `$3${targetOriginSuffix}`,
  )
  .replace(/\/\/([^./]+)\.([^./]+)\.([^./]+)\./, '//$1-$2.$3.')
  .replace(
    // eslint-disable-next-line @stylistic/max-len
    /\/\/review-([^.]+?)((-pwa)?(-(au|bg|cn|cy|gr|ee|hr|lt|lv|mt|ro|ru|sk|si))?)?\./,
    '//review-$1-pwa$4.',
  );

const getPortServer = (request) => {
  if (request.get('x-forwarded-port')) {
    return `:${request.get('x-forwarded-port')}`;
  }

  return '';
};

const getPortBrowser = () => {
  if (window.location.port) {
    return `:${window.location.port}`;
  }
  return '';
};

const redirectRouteToDomain = (
  route,
  exceptions = [],
  statusCode = 301,
) => (
  { req, res, query },
) => {
  // eslint-disable-next-line no-underscore-dangle
  const locale = req ? req.locale : window.__NEXT_DATA__.props.locale;
  const path = Routes.findAndGetUrls(route, query).urls.as;

  const hostname = req ? req.get('host') : window.location.hostname;
  const port = req ? getPortServer(req) : getPortBrowser();
  const origin = `https://${hostname}${port}`;
  const targetOrigin = getTargetOrigin(origin);

  if (
    ![...exceptions, 'en-US'].includes(locale)
    && hostname !== 'localhost'
  ) redirectToDomain(path, res, targetOrigin, statusCode);
  return {};
};

export default redirectRouteToDomain;
